/**
 * @generated SignedSource<<cc8dd96768335e76d3c5ec26ee9afe9c>>
 * @relayHash d8d4f460aee5d7da3b97bce5c3268b61
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fef0157df75b6b6bf9874538a53a5539b3747fdf9351fdfbad094892d18c4065

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GuildMembersScreenQuery$variables = {
  id: string;
};
export type GuildMembersScreenQuery$data = {
  readonly nodeBySlugId: {
    readonly __typename: "Guild";
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"GuildMembersEditorsSection_guild" | "GuildMembersNonOrganizersSection_guild" | "GuildMembersOrganizersSection_guild" | "GuildMembersPresentersSection_guild" | "GuildMetadata_guild">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type GuildMembersScreenQuery = {
  response: GuildMembersScreenQuery$data;
  variables: GuildMembersScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "backgroundPhoto",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v14 = {
  "alias": "legacyDefaultAvatarUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "transform",
      "value": {
        "dpr": 3,
        "fo": "auto",
        "h": 48,
        "w": 48
      }
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":48,\"w\":48})"
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GuildMembershipsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GuildMembership",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "membershipLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Guild",
            "kind": "LinkedField",
            "name": "guild",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UsersEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v4/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMe",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFollowing",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followerCount",
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": "organizerGuildMemberships",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "membershipLevel": "ORGANIZER"
                }
              },
              (v5/*: any*/)
            ],
            "concreteType": "GuildMembershipsConnection",
            "kind": "LinkedField",
            "name": "guildMemberships",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
          },
          {
            "alias": "editorGuildMemberships",
            "args": [
              {
                "kind": "Literal",
                "name": "condition",
                "value": {
                  "membershipLevel": "EDITOR"
                }
              },
              (v5/*: any*/)
            ],
            "concreteType": "GuildMembershipsConnection",
            "kind": "LinkedField",
            "name": "guildMemberships",
            "plural": false,
            "selections": (v16/*: any*/),
            "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v17/*: any*/)
    ],
    "storageKey": null
  },
  (v18/*: any*/)
],
v20 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GuildMembersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMetadata_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersOrganizersSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersEditorsSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersPresentersSection_guild"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "GuildMembersNonOrganizersSection_guild"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GuildMembersScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodeBySlugId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "organizers",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "organizers(first:3)"
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersOrganizersSection_guild_organizers",
                "kind": "LinkedHandle",
                "name": "organizers"
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "editors",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "editors(first:3)"
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersEditorsSection_guild_editors",
                "kind": "LinkedHandle",
                "name": "editors"
              },
              {
                "alias": null,
                "args": (v20/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "presenters",
                "plural": false,
                "selections": (v19/*: any*/),
                "storageKey": "presenters(first:12)"
              },
              {
                "alias": null,
                "args": (v20/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersPresentersSection_guild_presenters",
                "kind": "LinkedHandle",
                "name": "presenters"
              },
              {
                "alias": null,
                "args": (v20/*: any*/),
                "concreteType": "UsersConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UsersEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v8/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v7/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "members(first:12)"
              },
              {
                "alias": null,
                "args": (v20/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "GuildMembersNonOrganizersSection_guild_members",
                "kind": "LinkedHandle",
                "name": "members"
              }
            ],
            "type": "Guild",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fef0157df75b6b6bf9874538a53a5539b3747fdf9351fdfbad094892d18c4065",
    "metadata": {},
    "name": "GuildMembersScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9d329f38e82c6e0a13979eee61c62235";

export default node;
